import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import routes from "../routes/routes";
import { ROUTE_PERMISSIONS } from "../routes/routePermissions";

export default function ProtectedRoute({ children, requiredPermission }) {
  const { user, loading, hasPermission, sedes, sedeActiva, getDefaultRoute } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }}>
        <div style={{
          border: "6px solid #f3f3f3",
          borderTop: "6px solid #3498db",
          borderRadius: "50%",
          width: "50px",
          height: "50px",
          animation: "spin 1s linear infinite"
        }} />
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  if (!user) return <Navigate to={routes.login} replace />;

  /**
   * 🏥 VALIDACIÓN DE SEDE ACTIVA
   * Si el usuario está autenticado pero no ha seleccionado una sede activa
   * (y tiene sedes asignadas), lo redirigimos al Login/Home para que el selector haga su trabajo.
   */
  if (sedes && sedes.length > 0 && !sedeActiva) {
    return <Navigate to={routes.login} replace />;
  }

  // 👑 BYPASS SUPER-SU / ROL 1: Acceso completo a cualquier ruta
  if (user?.es_supersu || String(user?.rol) === "1") {
    return children;
  }

  /**
   * 🛡️ ENDURECIMIENTO DE SEGURIDAD (Deny-by-default)
   * Si una ruta requiere permisos pero se le pasa algo que NO es un Array válido
   * (por ejemplo, undefined debido a un error de tipeo en las keys de PATHS),
   * bloqueamos el acceso inmediatamente en lugar de ceder el paso.
   */
  const isValidPermission = requiredPermission === null || Array.isArray(requiredPermission);

  if (!isValidPermission) {
    if (process.env.NODE_ENV === "development") {
      console.error("[Guard Rail] ❌ requiredPermission inválido en ProtectedRoute:", requiredPermission);
    }
    return <Navigate to={routes.error} replace />;
  }

  if (Array.isArray(requiredPermission) && !hasPermission(requiredPermission)) {
    // Si intentó ingresar a Home ("/") pero no tiene permiso de Inicio (PATHS.INICIO),
    // redirigir dinámicamente al primer módulo autorizado en vez de arrojar un 404
    if (requiredPermission === ROUTE_PERMISSIONS[routes.home]) {
      const defaultRoute = typeof getDefaultRoute === "function" ? getDefaultRoute() : null;
      if (defaultRoute && defaultRoute !== routes.home && defaultRoute !== routes.error) {
        return <Navigate to={defaultRoute} replace />;
      }
    }

    return <Navigate to={routes.error} replace />;
  }

  return children;
}

